import './specimen-featured-list.scss'

import { defineComponent } from 'vue';
import { PropType } from 'vue';
import { pluck, tap } from 'rxjs/operators';

import { SearchParams, SpecimenResource, SearchResponse } from '@skinsoft/types';

import { NB_SPECIMENS_SEARCH_RESULT_CHANGED_TOPIC } from '@skinsoft/bus';
import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { TitleClickAction } from '../featured-card';
import { SpecimenFeaturedCard } from '@skinsoft/ui2'

export const SpecimenFeaturedList = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sSpecimenFeaturedCard: SpecimenFeaturedCard,
    },
    props: {
        searchParams: Object as PropType<SearchParams>,
        emptyMessage: String,
        titleClickAction: Object as PropType<TitleClickAction>,
        displayedButtons: {
            type: Array,
        },
        onlyInCache: {
            type: Boolean,
            default: false,
        },
        onlyUploaded: {
            type: Boolean,
            default: false,
        },
    },
    template: require('./specimen-featured-list.html'),
    data() {
        return {
            specimenFeatureds: [] as SpecimenResource[],
            totalResults: 0,
            targetRouteName: '/specimen'
        }
    },
    mounted() {
        this.unsubscribe()
        this.subscribe()
    },
    watch: {
        searchParams: {
            handler() {
                // Testing all search params presence to avoid useless search query during params setting
                if (this.searchParams && this.searchParams.nbResults && this.searchParams.sortType?.length) {
                    this.unsubscribe()
                    this.specimenFeatureds = []
                    this.$emit('totalCount', null)
                    this.subscribe()
                }
            },
            immediate: false,
            deep: true,
        },
    },
    methods: {
        subscribe() {
            const sortObject =
                this.searchParams && this.searchParams?.sortType?.length > 0
                    ? { entityFields: this.searchParams.sortType, sortAsc: this.searchParams.sortAsc }
                    : null

            if (this.onlyInCache || !window.navigator.onLine) {
                this.subscribeTo(
                    this.$specimenDataStore
                        .searchAllOffline(
                            {
                                queryText: this.searchParams?.queryText ?? "",
                                sortObject: sortObject,
                                pageSize: this.searchParams?.nbResults ?? 0,
                                language: this.getAppLocale(),
                            },
                            undefined,
                            undefined,
                            undefined,
                            this.onlyInCache,
                        ).pipe(
                            tap((result: SearchResponse<SpecimenResource>) => {
                                this.totalResults = result.totalSize
                            }),
                            pluck<SearchResponse<SpecimenResource>, SpecimenResource[]>('allData')
                        ),

                    (specimens: SpecimenResource[]) => {
                        this.specimenFeatureds = specimens
                        this.emitOnBus(NB_SPECIMENS_SEARCH_RESULT_CHANGED_TOPIC, { nbResults: specimens.length, totalResults: this.totalResults });
                    },
                    'specimenFeatureds'
                )
            } else {
                this.subscribeTo(
                    this.$specimenDataStore.searchAll(
                        {
                            queryText: this.searchParams?.queryText ?? "",
                            sortObject: sortObject,
                            pageSize: this.searchParams?.nbResults ?? 0,
                            language: this.getAppLocale()
                        },
                        undefined,
                        undefined,
                        undefined,
                        this.onlyInCache,
                    ).pipe(
                        tap((result: SearchResponse<SpecimenResource>) => {
                            this.totalResults = result.totalSize
                        }),
                        pluck<SearchResponse<SpecimenResource>, SpecimenResource[]>('allData')
                    ),

                    (specimens: SpecimenResource[]) => {
                        if (this.onlyUploaded) {
                            this.specimenFeatureds = specimens.filter(e => e.id.startsWith('_'))
                        } else {
                            this.specimenFeatureds = specimens
                        }
                        this.emitOnBus(NB_SPECIMENS_SEARCH_RESULT_CHANGED_TOPIC, { nbResults: specimens.length, totalResults: this.totalResults });
                    },
                    'specimenFeatureds',
                )
            }
        },
        unsubscribe() {
            this.unsubscribeFrom('specimenFeatureds')
        },
    },
})
